import { apiClient } from './client';

export interface GenerateReportParams {
  traineeIds?: string[];
  startDate: string;
  endDate: string;
}

export const reportApi = {

  /**
   * Send training set report via Telegram
   */
  async sendTrainingSetReport(setId: number): Promise<void> {
    await apiClient.post<void>(`/v1/reports/set/${setId}/send`, {});
  },
};
